/**
 * @generated SignedSource<<b86fa1eabd8ff3d62731939ee73af976>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type lessonBlocked_lesson$data = {
  readonly name: string;
  readonly " $fragmentType": "lessonBlocked_lesson";
};
export type lessonBlocked_lesson$key = {
  readonly " $data"?: lessonBlocked_lesson$data;
  readonly " $fragmentSpreads": FragmentRefs<"lessonBlocked_lesson">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "lessonBlocked_lesson",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "CourseClass",
  "abstractKey": "__isCourseClass"
};

(node as any).hash = "84799a4ea18eba350ec4ac9b297bc6eb";

export default node;
